(function () {
  const initImageCardGridNav = (section = document) => {
    section.querySelectorAll('.cust-image-card-grid--mobile-swipe').forEach((grid) => {
      if (grid.dataset.navReady === 'true') {
        return;
      }

      const track = grid.querySelector('.cust-image-card-grid__items');
      const prevButton = grid.querySelector('[data-image-card-grid-prev]');
      const nextButton = grid.querySelector('[data-image-card-grid-next]');

      if (!track || !prevButton || !nextButton) {
        return;
      }

      grid.dataset.navReady = 'true';

      const setButtonState = (button, disabled) => {
        button.classList.toggle('is-disabled', disabled);
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        button.disabled = disabled;
      };

      const updateNavState = () => {
        const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        const scrollLeft = Math.max(track.scrollLeft, 0);
        const boundaryTolerance = Math.min(Math.max(getStep() * 0.35, 32), 80);

        setButtonState(prevButton, scrollLeft <= boundaryTolerance);
        setButtonState(nextButton, scrollLeft >= maxScroll - boundaryTolerance);
      };

      const getStep = () => {
        const firstItem = track.querySelector('.cust-image-card-grid__item');

        if (!firstItem) {
          return track.clientWidth;
        }

        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

        return firstItem.getBoundingClientRect().width + gap;
      };

      const scrollByStep = (direction) => {
        const button = direction < 0 ? prevButton : nextButton;

        if (button.classList.contains('is-disabled')) {
          updateNavState();
          return;
        }

        track.scrollBy({
          left: getStep() * direction,
          behavior: 'smooth'
        });

        window.setTimeout(updateNavState, 450);
      };

      prevButton.addEventListener('click', () => scrollByStep(-1));
      nextButton.addEventListener('click', () => scrollByStep(1));
      track.addEventListener('scroll', updateNavState, { passive: true });
      track.addEventListener('scrollend', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState, { passive: true });
      requestAnimationFrame(updateNavState);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initImageCardGridNav());

  document.addEventListener('shopify:section:load', (event) => {
    initImageCardGridNav(event.target);
  });
})();
